module.exports = __webpack_public_path__ + "static/img/lifestyle_12.a75d4390.jpg";